
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 375,
  height: 154,
  viewBox: "0 0 375 154",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M393.794 82.717c-2.787-17.538-40.763-15.856-53.829-14.997-63.564 4.165-132.989 21.44-197.511 28.55-31.332 3.453-75.531 12.21-98.74-14.254C28.368 64.524 7.735 13.069-8.457 2.979c-1.917-1.19-9.677-5.5-9.542-.91v169.558h411.792v-88.91Z",
  fill: "#13051A"
})));

      const __svgRaw = "<svg width=\"375\" height=\"154\" viewBox=\"0 0 375 154\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M393.794 82.7169C391.007 65.1789 353.031 66.8608 339.965 67.7198C276.401 71.8848 206.976 89.1598 142.454 96.2698C111.122 99.7228 66.923 108.48 43.7132 82.0158C28.3686 64.5238 7.73585 13.0686 -8.4561 2.97861C-10.3727 1.7886 -18.1327 -2.52142 -17.9983 2.06857L-17.9983 171.627L393.794 171.627L393.794 82.7169Z\" fill=\"#13051A\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mobile-vector.59f8e02d02f2738fedfdcd095c241b96.svg"),
        {
          React: SvgMobileVector,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      